export default "__VITE_ASSET__DBWj5tj8__"